import { Breakpoints } from '@apps/gated-2021/breakpoints';
import styled from 'styled-components';
import { Input } from '../components/form.styled';

export const GatherPropertyDetails = styled.div`
    & .estimator-chart-preview {
        border-radius: 25px;
    }
`;

export const Inputs = styled(Input)`
    display: grid;
    grid-template-columns:
        minmax(auto, 144px) minmax(auto, 144px) minmax(auto, 250px)
        56px;

    gap: 10px;

    font-family: 'Public Sans';

    & .estimator-number-input {
        width: 100%;

        > main {
            align-items: center;
            padding: 0 15px;
        }

        > input {
            width: 100%;
        }
    }

    & .btn {
        font-family: 'Public Sans';
        font-weight: 800;

        padding: 0;
        border: none;
    }

    & .estimator-input {
        height: 56px;
        background-color: white;
        border-radius: 2px;
    }

    & .estimator-amenities-input {
        width: 100%;

        & .amenity-dropdown {
            min-width: 100%;
        }
    }

    & .amenity-select {
        padding: 0 15px;
        height: 56px;
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
    }
`;

export const BedroomsInput = styled.div`
    @media screen and (max-width: ${Breakpoints.mobile}) {
        grid-row: 1;
        grid-column: 1 / span 2;
    }
`;

export const BathroomsInput = styled.div`
    @media screen and (max-width: ${Breakpoints.mobile}) {
        grid-row: 1;
        grid-column: 3 / span 2;
    }
`;

export const AmenitiesInput = styled.div`
    @media screen and (max-width: ${Breakpoints.mobile}) {
        grid-row: 2;
        grid-column: 1 / span 3;
    }
`;

export const SubmitButton = styled.div`
    margin-top: 32px;

    & .btn {
        font-family: 'Public Sans';
        font-weight: 800;

        width: 100%;
        height: 56px;
    }

    @media screen and (max-width: ${Breakpoints.mobile}) {
        grid-row: 2;
        grid-column: 4 / span 1;
    }
`;
